const state = {
    invoiceId: null,
    tos: null,
};

const mutations = {
    SET_INVOICE_ID: (state, invoiceId) => {
        state.invoiceId = invoiceId;
    },   
    SET_TOS: (state, tos) => {
        state.tos = tos;
    }, 
};

const getters = {
    invoiceId: (state) => state.invoiceId,
    tos: (state) => state.tos,
};

const invoices = {
    state,
    getters,
    mutations,
};

export default invoices;